import {linearProgressClasses, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiLinearProgress = ({orderTrackerBar}: Tokens): ThemeOptions['components'] => {
  const {bar, progressBar} = orderTrackerBar;

  // This styling override is for Order tracker bar (order-list) and Request progress bar (prior auth). It enables more fine-grained customization for White Label clients
  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          '&.MuiLinearProgress-root': {
            height: 16,
            borderRadius: 20,
            outline: 2,
            outlineColor: bar.desktop.outline?.color || 'primary.main',
            outlineStyle: 'solid'
          }
        },
        colorPrimary: {
          [`&.${linearProgressClasses.colorPrimary}`]: {
            background: bar.desktop.background.color
          }
        },
        bar: {
          [`&.${linearProgressClasses.bar}`]: {
            borderRadius: 20,
            background: progressBar.desktop.color
          }
        }
      }
    }
  };
};
